import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Typography, Button, Grid, Box, Divider } from "@material-ui/core"
import YouTubeIcon from "@material-ui/icons/YouTube"
// import InstagramIcon from "@material-ui/icons/Instagram"
import FacebookIcon from "@material-ui/icons/Facebook"
import TwitterIcon from "@material-ui/icons/Twitter"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import Hootsuite from "../../../../../assets/hootsuite-icon.svg"
import TweetDeck from "assets/tweet-deck-icon.svg"
import { openIntegrationDialog } from "actions/integrations-dialog"
import SideBox from "components/SideBox"
import { openDisconnectIntegrationsDialog } from "actions/disconnect-integrations-dialog"

const IntegrationConnections = ({ fullScreen, classes, open, ...props }) => {
  const dispatch = useDispatch()
  const {
    twitter,
    facebook,
    linkedin,
    hootsuite,
    youtube,
    facebookPages,
    linkedinPages,
    twitterUser,
    youtubeUser,
    hootsuiteUser
  } = useSelector(state => state.organization.currentOrg)

  const [connected, setConnected] = useState({
    0: youtube,
    1: facebook,
    2: linkedin,
    3: twitter,
    4: hootsuite,
    5: twitter
  })
  useEffect(() => {
    setConnected({
      ...connected,
      0: youtube,
      1: facebook,
      2: linkedin,
      3: twitter,
      4: hootsuite,
      5: twitter
    })
  }, [facebook, twitter, linkedin, hootsuite, youtube])

  const handleOpenIntergrationDialog = () => {
    dispatch(openIntegrationDialog())
  }
  const handleOpen = network => {
    dispatch(openDisconnectIntegrationsDialog(network))
  }
  const Networks = [
    {
      YouTube: (
        <YouTubeIcon key={1} color="secondary" className={classes.icon} />
      )
    },
    {
      Facebook: (
        <FacebookIcon key={2} color="secondary" className={classes.icon} />
      )
    },
    {
      LinkedIn: (
        <LinkedInIcon key={3} color="secondary" className={classes.icon} />
      )
    },
    {
      Twitter: (
        <TwitterIcon key={4} color="secondary" className={classes.icon} />
      )
    },
    {
      Hootsuite: (
        <img src={Hootsuite} key={5} alt="Hootsuite" className={classes.icon} />
      )
    }
    // {
    //   TweetDeck: (
    //     <img src={TweetDeck} key={6} alt="TweetDeck" className={classes.icon} />
    //   )
    // }
  ]

  return (
    <Box className={classes.integrationsContainer}>
      <SideBox
        title={"Integrations"}
        content={
          <Grid container className={classes.integrationsBoxContainer}>
            <Grid container className={classes.contentContainer}>
              <Grid
                container
                direction="column"
                justify="space-evenly"
                alignItems="center"
                className={classes.intContainer}
              >
                <Grid className={classes.moreContainer}>
                  {Networks.map((network, index) =>
                    connected[index] ? (
                      <Grid
                        container
                        key={index}
                        xs={12}
                        alignItems="center"
                        className={classes.networkContainer}
                      >
                        <Grid xs={2}>{Object.values(network)}</Grid>
                        <Grid xs={6}>
                          <Typography variant="h5">
                            {Object.keys(network)}
                          </Typography>
                        </Grid>
                        <Grid xs={3}>
                          <Button
                            className={classes.buttonDisconnect}
                            onClick={() => handleOpen(Object.keys(network)[0])}
                            variant="text"
                          >
                            Disconnect
                          </Button>
                        </Grid>
                        <Grid xs={2} />
                        <Grid xs={6}>
                          {facebookPages !== null &&
                          //FACEBOOK DATA
                          /* eslint-disable */
                          Object.keys(network)[0] === "Facebook"
                            ? facebookPages[1] !== null &&
                              facebookPages[1].length > 0 && (
                                <Typography className={classes.userAccount}>
                                  {facebookPages[1] + " Account"}
                                </Typography>
                              )
                            : null}
                          {facebookPages !== null &&
                          Object.keys(network)[0] === "Facebook"
                            ? facebookPages[0] !== null &&
                              facebookPages[0].length > 0 && (
                                <Typography className={classes.connectedPages}>
                                  {"Connected Page(s):"}
                                </Typography>
                              )
                            : null}
                          {facebookPages !== null &&
                          Object.keys(network)[0] === "Facebook" &&
                          facebookPages[0] !== null &&
                          facebookPages[0].length > 0
                            ? facebookPages[0].map((x, i) => {
                                return (
                                  <Typography style={{ color: "gray" }}>
                                    {x}
                                  </Typography>
                                )
                              })
                            : null}
                          {linkedinPages !== null &&
                          //LINKEDIN DATA
                          /* eslint-disable */
                          Object.keys(network)[0] === "LinkedIn"
                            ? linkedinPages[1] !== null &&
                              linkedinPages[1].length > 0 && (
                                <Typography className={classes.userAccount}>
                                  {linkedinPages[1] + " Account"}
                                </Typography>
                              )
                            : null}
                          {linkedinPages !== null &&
                          Object.keys(network)[0] === "LinkedIn"
                            ? linkedinPages[0] !== null &&
                              linkedinPages[0].length > 0 && (
                                <Typography className={classes.connectedPages}>
                                  {"Connected Page(s):"}
                                </Typography>
                              )
                            : null}
                          {linkedinPages !== null &&
                            Object.keys(network)[0] === "LinkedIn" &&
                            linkedinPages[0] !== null &&
                            linkedinPages[0].length > 0 &&
                            linkedinPages[0].map(x => {
                              return (
                                <Typography style={{ color: "gray" }}>
                                  {x}
                                </Typography>
                              )
                            })}

                          {youtubeUser !== null &&
                            Object.keys(network)[0] === "YouTube" && (
                              <Typography className={classes.userAccount}>
                                {youtubeUser + " Account"}
                              </Typography>
                            )}
                          {twitterUser !== null &&
                            Object.keys(network)[0] === "Twitter" && (
                              <Typography className={classes.userAccount}>
                                {twitterUser + " Account"}
                              </Typography>
                            )
                          // eslint-enable
                          }
                          {hootsuiteUser !== null &&
                            Object.keys(network)[0] === "Hootsuite" && (
                              <Typography className={classes.userAccount}>
                                {hootsuiteUser + " Account"}
                              </Typography>
                            )
                          // eslint-enable
                          }
                        </Grid>
                        <Grid xs={3} />
                        <Divider style={{ width: "100%", marginTop: "10px" }} />
                      </Grid>
                    ) : (
                      ""
                    )
                  )}
                  {connected[1] === 0 &&
                    connected[2] === 0 &&
                    connected[3] === 0 &&
                    connected[4] === 0 && (
                      <Typography
                        variant="h5"
                        className={classes.noPlatformsConnected}
                      >
                        No social media connected.
                      </Typography>
                    )}
                </Grid>
              </Grid>
            </Grid>
            <Grid container className={classes.addContainer}>
              <Button
                onClick={handleOpenIntergrationDialog}
                variant="contained"
                color="primary"
                className={classes.actionButton}
              >
                Add New
              </Button>
            </Grid>
          </Grid>
        }
      />
    </Box>
  )
}

export default withStyles(styles)(IntegrationConnections)



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/IntegrationConnections/index.jsx